/** @format */

/**
 * Gets the CSS `display` property. Toggles the display as on some pages we don't want to show it
 *
 * @param shouldDisplayCustomLauncher If we should display the button
 */
export const getDisplay = (shouldDisplayCustomLauncher: boolean) => {
    return shouldDisplayCustomLauncher ? 'flex' : 'none';
};

/**
 * Gets the CSS `bottom` property. When using the sticky footer we
 * want to display the Intercom button above the footer
 *
 * @param stickyFooterHeight The height of the sticky footer
 */
export const getBottom = (stickyFooterHeight: number) => {
    return `${Math.max(24, stickyFooterHeight + 12)}px`;
};
